var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SjCard',{staticStyle:{"width":"100%","height":"240px"}},[_c('SjBlank')],1),_vm._v(" 自定义文本 "),_c('SjCard',{staticStyle:{"width":"100%","height":"240px"}},[_c('SjBlank',{attrs:{"text":"不符合要求"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }